import { render } from "./RacesEventMeeting.vue?vue&type=template&id=f353fde4&scoped=true"
import script from "./RacesEventMeeting.vue?vue&type=script&lang=js"
export * from "./RacesEventMeeting.vue?vue&type=script&lang=js"

import "./RacesEventMeeting.vue?vue&type=style&index=0&id=f353fde4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f353fde4"]])

export default __exports__